import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type ShipperAttachment } from '../domain/Document'
import { ShipperRepository } from '../infra/ShipperRepository'

export type ListShipperAttachmentsFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function listShipperAttachmentsFactory({
  shipperRepository,
}: ListShipperAttachmentsFactoryDependencies) {
  return async function (
    uuid: string,
    config?: { signal?: AbortSignal }
  ): Promise<ShipperAttachment[]> {
    return shipperRepository.listShipperAttachments(uuid, config)
  }
}

export function listShipperAttachments(
  uuid: string,
  config?: { signal?: AbortSignal }
): Promise<ShipperAttachment[]> {
  const httpClient = new HttpClient(API_URL)
  const shipperRepository = new ShipperRepository({ httpClient })
  const listFn = listShipperAttachmentsFactory({ shipperRepository })
  return listFn(uuid, config)
}
